import React, { useEffect, useState, useRef } from "react";
import { MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import { useDispatch, useSelector } from "react-redux";
import { choseToggle } from "helpers/toggleIfLoading";
import { useHttp } from "hooks/useHttp";
import Select from "react-select";
import addNotification from "helpers/notify";
import { getRecentBrandSettings, updateBulkBrandSettings } from "api/brands/brandSettings";

export default function BrandSettingsBulkAssignModel(props) {
  const dispatch = useDispatch();
  const milestonesRedux = useSelector((s) => s.user.milestones);
  const userInfoRedux = useSelector((s) => s.user.userInfo);
  const projectsRedux = useSelector((s) => s.user.projects);
  const [include2DElements, setInclude2DElements] = useState(false);
  const [includeMiscellaneous, setIncludeMiscellaneous] = useState(false);
  const [milestones, setMilestones] = useState([]);
  const [selectedMilestone, setSelectedMilstone] = useState(null);
  const [recentBrandSettings, setRecenetBrandSettings] = useState(false);

  useEffect(() => {
    setMilestones(
      milestonesRedux?.map((i) => ({
        label: i.key,
        value: i._id,
      }))
    );
  }, [milestonesRedux]);

  const parentProjectOptions = projectsRedux?.map((i) => ({
    label: i.title,
    value: i._id,
  }));

  const handle2DElementCheckbox = (value = false) => {
    setInclude2DElements(value);
  };

  const handleMiscellaneousElementCheckbox = (value = false) => {
    setIncludeMiscellaneous(value);
  };

  const hanldeProjectSettingApiRequest = () => {
    const payload = props?.bulkEditProject?.map((item) => {
      return {
        _id: item?.projectBrandSettings,
        companyId: userInfoRedux?.company,
        projectId: item?._id,
        milestone: selectedMilestone?.value,
        includeMiscellaneous: includeMiscellaneous,
        include2DElements: include2DElements,
      };
    });

    updateBulkBrandSettingsAPI(payload);
  };

  const toggle = () => {
    props.toggle();
  };

  const { loading: updateLoading, request: updateBulkBrandSettingsAPI } =
    useHttp({
      requestCallback: (data) => updateBulkBrandSettings(data),
      onLoad: (res) => {
        addNotification("Bulk Export Settings Updated Successfully", "success");
      },
      onError: (res) => {
        console.log(res, res);
        addNotification("Something went wrong", "danger");
      },
    });

  useEffect(() => {
    setRecenetBrandSettings(props.recentBrandSettings);
    handle2DElementCheckbox(props.recentBrandSettings?.include2DElements);
    handleMiscellaneousElementCheckbox(
      props.recentBrandSettings?.includeMiscellaneous
    );
    const settingMileStone = milestones?.find(
      (mileStoneItem) =>
        mileStoneItem?.value === props.recentBrandSettings?.milestone
    );

    setSelectedMilstone(settingMileStone);
  }, [props.recentBrandSettings]);

  return (
    <MDBModal
      isOpen={props.isOpen}
      toggle={choseToggle(updateLoading, toggle)}
      centered
      className="create-modal-full-size"
    >
      <MDBModalHeader toggle={choseToggle(updateLoading, toggle)}>
        Export Settings Bulk Assign
      </MDBModalHeader>
      <MDBModalBody className="pt-1">
        <div className="p-3">
          <div className="border rounded-3 bg-white p-3 pb-4">
            <div className="form-group-div">
              <div>
                <label className="inter pl-2">Status</label>
                <Select
                  options={milestones}
                  value={selectedMilestone}
                  onChange={(options) => setSelectedMilstone(options)}
                />
              </div>
            </div>
          </div>

          <div className="border rounded-3 bg-white p-3 pb-4 mt-3">
            <label className="inter pl-2 f-14">
              Additional export configuration
            </label>
            <div>
              <div className="form-check">
                <input
                  className="form-check-input squared-checkbox"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                  checked={includeMiscellaneous}
                  onChange={(e) =>
                    handleMiscellaneousElementCheckbox(e?.target?.checked)
                  }
                />
                <label
                  className="form-check-label f-14 inter"
                  htmlFor="flexCheckDefault"
                >
                  Include rooms spaces and miscellaneous items
                </label>
              </div>
              <div className="form-check mt-3">
                <input
                  className="form-check-input squared-checkbox"
                  type="checkbox"
                  value=""
                  id="flexCheckChecked"
                  checked={include2DElements}
                  onChange={(e) => handle2DElementCheckbox(e?.target?.checked)}
                />
                <label
                  className="form-check-label inter f-14"
                  htmlFor="flexCheckChecked"
                >
                  Include 2D Elements
                </label>
              </div>
            </div>
          </div>

          <div
            className="header-btn bg-bid text-white border-bid rounded-lg h6 mx-auto mb-0 cursor-pointer w-25 justify-content-center mt-3"
            onClick={() => hanldeProjectSettingApiRequest()}
          >
            <span className="f-14">
              {updateLoading ? (
                <i className="fa fa-spinner small-spinner mr-2" />
              ) : (
                <i className="fa fa-save mr-2 "></i>
              )}
              Save
            </span>
          </div>
        </div>
      </MDBModalBody>
    </MDBModal>
  );
}
